import qs from 'qs'

export function getQueryStringParams(search) {
  return qs.parse(search, {
    ignoreQueryPrefix: true,
    decoder: str => {
      return str === 'false' ? false : str === 'true' ? true : str
    },
  })
}

export function objectToQueryString(obj: {}) {
  return qs.stringify(obj, { addQueryPrefix: true, skipNulls: true })
}
